<template>
  <div class="product-stock-status-wrapper">
    <!-- stock list -->
    <div class="partners-stock-menu">
      <p class="not-available" v-if="!hasAnyStocks">
        {{ $translate('NO_PARTNER_STOCKS') }}
      </p>
      <table v-else>
        <tbody>
          <tr
            v-if="webPartner"
            :class="{ 'stock-row-unavailable': isUnavailableStatus(webStockStatus.class) }"
          >
            <td>{{ webPartner.name || defaultWebPartnerName }}</td>
            <td :class="webStockStatus.class">
              {{ webStockStatus.text }}
            </td>
          </tr>
          <tr
            v-for="p in filteredPartnerStocks"
            :key="p.id"
            :class="{ 'stock-row-unavailable': isUnavailableStatus(getPartnerStockStatus(p).class) }"
          >
            <td>{{ p.name }}</td>
            <td :class="getPartnerStockStatus(p).class">
              {{ getPartnerStockStatus(p).text }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import {computed, inject } from 'vue';
const { $translate } = inject('i18n');

const props = defineProps({
  allowCheckout: {
    required: true,
    type: Boolean
  },
  stock: {
    required: true,
    type: [Number, String]
  },
  extraField2: {
    required: true,
    type: Boolean
  },
  partnerStocks: {
    type: Array,
    default: () => []
  },
  minAmount: {
    required: true,
    type: [Number, String]
  },
})

const webPartner = computed(() =>
  props.partnerStocks.find((p) => p.id === 1)
);

const defaultWebPartnerName = computed(() => {
  const translated = $translate('C_ONLINE_WAREHOUSE');
  return translated && translated !== 'C_ONLINE_WAREHOUSE' ? translated : 'Onlinelager';
});

const webStockStatus = computed(() => {
  const quantity = Number(webPartner.value?.quantity ?? NaN);
  const orderItem = Boolean(props.extraField2);
  const allowCheckout = Boolean(props.allowCheckout);
  const minAmountAllowed = Number(props.minAmount);

const inStock         = quantity > 0;
const meetsMinAmount  = quantity > minAmountAllowed;

// 1) Beställninsgvara
if (orderItem) {
  return {
    text:  $translate('NON_STOCK'),
    class: 'stock-warning'
  };
}

// 2) Lagervara
if (inStock && meetsMinAmount) {
  //i lager, fler än minsta beställning
  return {
    text:  $translate('C_IN_STOCK_ONLINE'),
    class: 'in-stock'
  };
}

if (!inStock) {
  // inte i lager
  if (allowCheckout) {
    return {
      text:  $translate('C_TEMP_OUT_OF_STOCK_PRODUCT'),
      class: 'temp-out-of-stock'
    };
  }
  return {
    text:  $translate('C_OUT_OF_STOCK_ONLINE'),
    class: 'out-of-stock'
  };
}

// Finns i lager men färre än minsta köpantal
return {
  text:  $translate('C_OUT_OF_STOCK_ONLINE'),
  class: 'out-of-stock'
};
});

const filteredPartnerStocks = computed(() =>
  props.partnerStocks.filter((p) => p.id !== 1)
);

const hasAnyStocks = computed(() =>
  !!webPartner.value || filteredPartnerStocks.value.length > 0
);

const getPartnerStockStatus = (partner) => {
  const quantity = partner.quantity;

  if (quantity > 0) {
    return { text: $translate('IN_STOCK'), class: 'in-stock' };
  }

  return { text: $translate('OUT_OF_STOCK'), class: 'out-of-stock' };
};

const isUnavailableStatus = (statusClass) =>
  statusClass === 'out-of-stock' || statusClass === 'temp-out-of-stock';
</script>
